import {
  BrowserPdfDownloadService,
  type PdfDownloadService,
} from "../pdf-download/index.js";
import type {
  PlatformGlobals,
  PlatformGlobalsFactory,
} from "./PlatformGlobals.js";

export class BrowserPlatformGlobalsFactory implements PlatformGlobalsFactory {
  build(_input: { readonly trpc: unknown }): PlatformGlobals {
    return {
      pdfDownload: buildPdfDownload(),
      origin: window.location.origin,
    };
  }
}

const buildPdfDownload = (): PdfDownloadService =>
  new BrowserPdfDownloadService({
    window: {
      open: (url, target) => window.open(url, target ?? "_blank"),
      URL: {
        createObjectURL: (b) => URL.createObjectURL(b),
        revokeObjectURL: (u) => URL.revokeObjectURL(u),
      },
      atob: (s) => window.atob(s),
    },
    document: {
      createElement: (tag) => document.createElement(tag),
      body: document.body,
    },
  });
